<template>
	<div class="sort-container">
		
		<div class="sort-item" @click="handleClickItem(index)" v-for="(item,index) in sortList" :key="item.id">
			<div :class="[selectIndex==index?'item-select':'item-unselect']">{{item}}</div>
			<!-- <img class="item-icon" v-show="index!=0" :src="(isDown&&index==selectIndex)?'../../assets/images/icon_jt%20拷贝@2x.png':'../../assets/images/icon_jt@2x.png'"/> -->
			<div v-if="index!=0">
				<img class="item-icon" v-if="(isDown&&index==selectIndex)" src="../../assets/images/icon_jt 拷贝@2x.png"/>
				<img class="item-icon" v-else src="../../assets/images/icon_jt@2x.png"/>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			sortList:{
				type:Array,
				default:[]
			}
		},
		data() {
			return {
				isDown: true,		// 是否倒序排序
				selectIndex: 0		// 选中的索引
			}
		},
		methods:{
			handleClickItem(index) {
				if (index == this.selectIndex) {
					this.isDown = !this.isDown 
				}else {
					this.selectIndex = index
					this.isDown = true
				}
				this.$emit("on-change",this.selectIndex,this.isDown)
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	@import "./index.less";
</style>
